import classNames from 'classnames';
import { forwardRef, memo, type ReactNode } from 'react';

import { ChevronDownIcon } from '@air/design-icons';
import { Button, type ButtonProps } from '@air/primitive-button';

import { CURRENT_WORKSPACE_BUTTON } from '~/constants/testIDs';

export type CurrentWorkspaceHeaderTriggerProps = ButtonProps & {
  avatar?: ReactNode;
  title?: string;
};

export const _CurrentWorkspaceHeaderTrigger = forwardRef<HTMLButtonElement, CurrentWorkspaceHeaderTriggerProps>(
  ({ avatar, className, title, ...restOfProps }, forwardedRef) => {
    return (
      <Button
        appearance="ghost"
        color="gray"
        className={classNames('-ml-2 min-w-0 px-2', className)}
        data-testid={CURRENT_WORKSPACE_BUTTON}
        prefix={avatar}
        suffix={<ChevronDownIcon className="ads:text-icon-default text-gray-10" size="sm" />}
        ref={forwardedRef}
        {...restOfProps}
      >
        <div className="truncate font-semibold ads:text-metadata text-18 text-gray-10">{title}</div>
      </Button>
    );
  },
);

_CurrentWorkspaceHeaderTrigger.displayName = '_CurrentWorkspaceHeaderTrigger';

export const CurrentWorkspaceHeaderTrigger = memo(_CurrentWorkspaceHeaderTrigger);

CurrentWorkspaceHeaderTrigger.displayName = 'CurrentWorkspaceHeaderTrigger';
